import React, { Component } from "react";
import { Link } from "react-router-dom";
import style from "./SubcategoryItem.module.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { addQuoteItem } from "../redux/actions";
import { Button } from "react-bootstrap";
import Image from "./shared/Image";

class SubCategoryItem extends Component {

  get url() {
    return `/category/${this.props.SubcategoryItem.id}`;
  }
  get name() {
    return this.props.SubcategoryItem.name;;
  }

  get image() {
    return this.props.SubcategoryItem.image;
  }

  get description() {

    var div = document.createElement("div");
    div.innerHTML = this.props.SubcategoryItem.description;
    var descriptionText = div.textContent || div.innerText || "";
    return descriptionText;
  }

  render() {
    return (
      <div className={[style.root,style[this.props.view]].join(" ")}>
        <Link className={style.imageLink} to={this.url}>
          <Image
            className={style.image}
            src={this.image}
            alt={this.name}
          />
        </Link>

        <Link
          title={this.name}
          className={style.name}
          to={this.url}
        >
          {this.name}
        </Link>

        <div className={style.description}>{this.description}</div>

          <Button
            as={Link}
            className={style.btnConfig}
            to={this.url}
            variant="primary"
          >
            View Products
          </Button>
      </div>
    );
  }
}

SubCategoryItem.propTypes = {
  subcategory: PropTypes.object.isRequired,
  view: PropTypes.oneOf(["grid", "list"])
};

export default connect(undefined, { addQuoteItem })(SubCategoryItem);
